import { Gmoshop } from '@linktivity/link-connect';

const CardNetwork = Gmoshop.CardNetwork;
type CardNetwork = Gmoshop.CardNetwork;

const OrderStatus = Gmoshop.OrderStatus;
type OrderStatus = Gmoshop.OrderStatus;

export { CardNetwork, OrderStatus };
